const GiftWithPurchase = {
  giftVariantId: 44632661459120,
  threshold: 7500,
  storageKey: "gift_declined",
  isProcessing: false,

  init() {
    this.interceptCartRequests();
    this.interceptXHR();
    this.bindCartEvents();
    this.bindFormSubmissions();
    this.bindAllForms();
    this.bindAddToCartButtons();
    this.listenForThemeEvents();
    this.injectStyles();
    this.checkCart();
  },

  interceptCartRequests() {
    const originalFetch = window.fetch;
    const self = this;

    window.fetch = async (...args) => {
      const response = await originalFetch(...args);
      const url = args[0]?.toString() || "";

      if (
        url.includes("/cart/add") ||
        url.includes("/cart/change") ||
        url.includes("/cart/update") ||
        url.includes("/cart/clear")
      ) {
        setTimeout(() => self.checkCart(), 100);
      }

      return response;
    };
  },

  interceptXHR() {
    const self = this;
    const originalOpen = XMLHttpRequest.prototype.open;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.addEventListener("load", function () {
        if (
          url.includes("/cart/add") ||
          url.includes("/cart/change") ||
          url.includes("/cart/update")
        ) {
          setTimeout(() => self.checkCart(), 100);
        }
      });
      return originalOpen.apply(this, arguments);
    };
  },

  listenForThemeEvents() {
    const events = [
      "cart:updated",
      "cart:refresh",
      "cart:change",
      "ajaxCart:updated",
      "cart:item-added",
      "product:added",
    ];
    events.forEach((event) => {
      document.addEventListener(event, () => this.checkCart());
    });
  },

  bindFormSubmissions() {
    document.addEventListener("submit", (e) => {
      const form = e.target;
      if (
        form.action?.includes("/cart/add") ||
        form.action?.includes("/cart")
      ) {
        setTimeout(() => this.checkCart(), 500);
      }
    });
  },

  bindAllForms() {
    document.addEventListener("submit", () => {
      setTimeout(() => this.checkCart(), 500);
    });
  },

  bindAddToCartButtons() {
    document.addEventListener("click", (e) => {
      const btn = e.target.closest(
        '[type="submit"][name="add"], .product-form__submit, [data-add-to-cart], .add-to-cart'
      );
      if (btn) {
        setTimeout(() => this.checkCart(), 500);
        setTimeout(() => this.checkCart(), 1000);
      }
    });
  },

  bindCartEvents() {
    document.addEventListener("click", (e) => {
      const removeBtn = e.target.closest(
        '[data-variant-id="44632661459120"], [href*="variant=44632661459120"]'
      );
      if (removeBtn) {
        sessionStorage.setItem(this.storageKey, "true");
      }
    });
  },

  injectStyles() {
    const css = `
      .gift-callout {
        background: linear-gradient(135deg, #f0fdf4 0%, #dcfce7 100%);
        border: 1px solid #86efac;
        border-radius: 8px;
        padding: 12px 16px;
        margin: 16px;
        display: flex;
        align-items: center;
        gap: 10px;
        font-size: 14px;
        color: #166534;
      }
      .gift-callout--progress {
        background: linear-gradient(135deg, #fefce8 0%, #fef9c3 100%);
        border-color: #fde047;
        color: #854d0e;
      }
      .gift-callout__icon {
        font-size: 20px;
        flex-shrink: 0;
      }
      .gift-callout__text {
        flex-grow: 1;
      }
      .gift-callout__text strong {
        display: block;
        margin-bottom: 2px;
      }
      .gift-callout__progress-bar {
        height: 6px;
        background: #fef08a;
        border-radius: 3px;
        margin-top: 8px;
        overflow: hidden;
      }
      .gift-callout__progress-fill {
        height: 100%;
        background: #eab308;
        border-radius: 3px;
        transition: width 0.3s ease;
      }
    `;
    const style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);
  },

  async getCart() {
    const res = await fetch("/cart.js");
    return res.json();
  },

  async addGift() {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        items: [{ id: this.giftVariantId, quantity: 1 }],
        sections: this.getSectionIds(),
      }),
    });
    const data = await response.json();
    this.renderSections(data.sections);
    this.refreshCart();
  },

  async removeGift() {
    const cart = await this.getCart();
    const giftItem = cart.items.find(
      (item) => item.variant_id == this.giftVariantId
    );

    if (giftItem) {
      const response = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: giftItem.key,
          quantity: 0,
          sections: this.getSectionIds(),
        }),
      });
      const data = await response.json();
      this.renderSections(data.sections);
      this.refreshCart();
    }
  },

  getSectionIds() {
    return [
      "cart-drawer",
      "cart-icon-bubble",
      "cart-notification-product",
      "cart-notification-button",
      "main-cart-items",
      "cart-live-region-text",
    ];
  },

  renderSections(sections) {
    if (!sections) return;

    for (const [id, html] of Object.entries(sections)) {
      const selector = `#shopify-section-${id}`;
      const el = document.querySelector(selector);

      if (el) {
        el.innerHTML =
          new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector)?.innerHTML || "";
      }
    }
  },

  refreshCart() {
    // Try Dawn's pub/sub if available
    if (window.Shopify && window.Shopify.theme && window.Shopify.theme.pubsub) {
      window.Shopify.theme.pubsub.publish("cart:refresh");
    }

    // Try to find and call cart drawer's refresh
    const cartDrawer = document.querySelector("cart-drawer");
    if (cartDrawer && typeof cartDrawer.refresh === "function") {
      cartDrawer.refresh();
    }

    this.updateCartCount();
    this.updateCallout();
  },

  async updateCartCount() {
    const cart = await this.getCart();
    const bubble = document.querySelector(".cart-count-bubble");
    if (bubble) {
      if (cart.item_count > 0) {
        bubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
        bubble.classList.remove("hidden");
      } else {
        bubble.classList.add("hidden");
      }
    }
  },

  async updateCallout() {
    const cart = await this.getCart();

    const cartTotal = cart.items.reduce((sum, item) => {
      return item.variant_id == this.giftVariantId
        ? sum
        : sum + item.final_line_price;
    }, 0);

    const hasGift = cart.items.some(
      (item) => item.variant_id == this.giftVariantId
    );

    // Remove existing callouts
    document.querySelectorAll(".gift-callout").forEach((el) => el.remove());

    // Check if gift variant is visible in cart items
    const cartItemNames = document.querySelectorAll(".cart-item__name");
    const giftVisibleInCart = Array.from(cartItemNames).some((el) =>
      el.href?.includes(this.giftVariantId)
    );

    if (giftVisibleInCart) return;

    // Find the existing banner to place into
    const existingBanner = document.querySelector(".drawer__footer");
    if (!existingBanner) return;

    let calloutHtml = "";

    if (hasGift) {
      calloutHtml = `
        <div class="gift-callout" style="background-color: #efefef; display: flex; flex-direction: column; width: 100%; max-width: 100%; border-radius: 0px 0px 0px 0px; margin: 10px 0px 10px 0px; border: 0 solid #000000;">
          <div style="display: flex; flex-direction: row; align-self: center; width: 100%;">
            <div style="display: flex; flex-direction: column; justify-content: center; width: 100%; color: #000000; margin: 12px 12px 12px 12px;">
              <p class="body-text" style="margin: 0px; color: #000000; font-weight: inherit; font-size: inherit; text-align: center; line-height: inherit; letter-spacing: inherit;"><span style="font-weight: bold; color: #000000;">Free gift added!</span> 🎁 <span style="font-weight: bold;">Applied at checkout</span></p>
            </div>
          </div>
        </div>
      `;
    } else if (cartTotal > 0 && cartTotal < this.threshold) {
      const remaining = ((this.threshold - cartTotal) / 100).toFixed(2);

      calloutHtml = `
        <div class="gift-callout" style="background-color: #efefef; display: flex; flex-direction: column; width: 100%; max-width: 100%; border-radius: 0px 0px 0px 0px; margin: 10px 0px 10px 0px; border: 0 solid #000000;">
          <div style="display: flex; flex-direction: row; align-self: center; width: 100%;">
            <div style="display: flex; flex-direction: column; justify-content: center; width: 100%; color: #000000; margin: 12px 12px 12px 12px;">
              <p class="body-text" style="margin: 0px; color: #000000; font-weight: inherit; font-size: inherit; text-align: center; line-height: inherit; letter-spacing: inherit;"><span style="font-weight: bold; color: #000000;">Spend $${remaining} more for a FREE gift!</span> 🎁</p>
            </div>
          </div>
        </div>
      `;
    }

    if (calloutHtml) {
      existingBanner.insertAdjacentHTML("afterbegin", calloutHtml);
    }
  },

  async checkCart() {
    if (this.isProcessing) return;
    this.isProcessing = true;

    try {
      const cart = await this.getCart();

      const cartTotal = cart.items.reduce((sum, item) => {
        return item.variant_id == this.giftVariantId
          ? sum
          : sum + item.final_line_price;
      }, 0);

      const hasGift = cart.items.some(
        (item) => item.variant_id == this.giftVariantId
      );
      const declined = sessionStorage.getItem(this.storageKey) === "true";

      if (cartTotal >= this.threshold && !hasGift && !declined) {
        await this.addGift();
      }

      if (cartTotal < this.threshold && hasGift) {
        sessionStorage.removeItem(this.storageKey);
        await this.removeGift();
      }

      // Always update callout
      this.updateCallout();
    } finally {
      setTimeout(() => {
        this.isProcessing = false;
      }, 200);
    }
  },
};

document.addEventListener("DOMContentLoaded", () => GiftWithPurchase.init());
